import { createSlice } from '@reduxjs/toolkit';

export const couponErrorMsg = createSlice({
  name: 'couponErrorMsg',
  initialState: {
    data: '',
  },

  reducers: {
    setCouponErrorMsg: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setCouponErrorMsg } = couponErrorMsg.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getCouponErrorMsg = (state) => {
  return state.couponErrorMsg.data;
};

export default couponErrorMsg.reducer;
